import {
    Component,
    Input,
    OnInit
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AnalyticalTest } from '../../../model/analytical-test/analytical-test.model';
import {
    CART_GROUP_TYPE_SERVICE,
    CART_ITEM_TYPE_PRODUCT,
    CART_ITEM_TYPE_SERVICE,
    CartItem,
    CartSampling,
    UnavailableCartItem
} from '../../../model/cart.model';
import { CatalogueItem } from '../../../model/catalogue-category/catalogue-item.model';
import * as fromApp from '../../../store/app.reducers';
import * as CartActions from '../../../store/cart/cart.actions';

@Component({
    selector: 'app-unavailable-cart-item',
    templateUrl: './unavailable-cart-item.component.html',
    styleUrls: ['./unavailable-cart-item.component.scss']
})
export class UnavailableCartItemComponent implements OnInit {

    @Input() cartItem: UnavailableCartItem;
    @Input() last: boolean;
    @Input() detailed = false;
    @Input() groupType: string;
    @Input() cartSampling: CartSampling;

    constructor(private store: Store<fromApp.AppState>) { }

    ngOnInit() {
    }

    deleteCartItem() {
        let item;
        if (this.groupType === CART_GROUP_TYPE_SERVICE) {
            item = new AnalyticalTest(this.cartItem.id, this.cartItem.name, '', null, '', '');
            item.resourceType = CART_ITEM_TYPE_SERVICE;
        } else {
            item = new CatalogueItem(this.cartItem.id, this.cartItem.name, '', '', 0, null, [], 0, CART_ITEM_TYPE_PRODUCT);
        }
        const unavailableCartItem: CartItem = new CartItem(item, 0, null, null, this.groupType);
        this.store.dispatch(new CartActions.UpdateCartItem(unavailableCartItem, this.cartSampling));
    }
}
